/**
 * Created by Gaurav on Oct/15/2019.
 */

import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {
    IStillImageBackgroundConfig,
    StillImageBackground
} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BarbarianFuryGameAssets} from "../BarbarianFuryGameAssets";
import {BarbarianFuryGameConfig} from "../BarbarianFuryGameConfig";
import {BFGameEvent} from "../events/BFGameEvent";
import {BarbarianFuryGameMode} from "../gamemode/BarbarianFuryGameMode";
import {BarbarianFuryParsedInitData} from "../server/data/BarbarianFuryParsedInitData";

export class BarbarianFuryBackground extends StillImageBackground {
    private _reelForeground:PIXI.Container;
    private _gameForeground:ScalableLayer;
    private _snowBackground:ScalableLayer;
    private _reelBackground:ScalableLayer;

    private _winCountupScreen:ScalableLayer;
    private _bigwinScreen:ScalableLayer;

    private _reelFrame:PIXI.Sprite;
    private _stoneForeground:PIXI.Sprite;
    private _frameChainLeft:PIXI.Sprite;
    private _frameChainRight:PIXI.Sprite;
    private _fsMoon:PIXI.Sprite;

    private _fireParticlesAnim:TimelineSprite;

    private _isRestored:boolean = false;
    private _gameMode:string = "";
    private _deviceOrientation:string = "portrait";
    private _gameLogo:PIXI.Sprite;

    private _snowContainer:PIXI.Container;
    private _reelBottomFire:PIXI.Container;

    private _screenWidth:number;
    private _screenHeight:number;

    constructor(config:IStillImageBackgroundConfig) {
        super(config);

        this._reelForeground = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.REEL_FOREGROUND.name);
        this._gameForeground = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.FOREGROUND.name);
        this._snowBackground = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.SNOW_FALL_IN_BG.name);
        this._reelBackground = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.REEL_BACKGROUND.name);

        this._winCountupScreen = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.WIN_COUNT_UP.name);
        this._bigwinScreen = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.BIG_WIN.name);
    }

    protected initAnimations():void {
        super.initAnimations();
        this.createGameGraphics();
    }

    protected addEventListeners():void {
        super.addEventListeners();

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    protected onInitDataParsed(data:BarbarianFuryParsedInitData):void {
        this._isRestored = data.isRestoreState;
        this._gameMode = data.mode;
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize && super.onResize(resizeData);
        this._screenWidth = resizeData.width / this._gameForeground.scale.x;
        this._screenHeight = resizeData.height / this._gameForeground.scale.y;
        this._deviceOrientation = resizeData!.orientation;
        this.arrangeGraphicsOnResize(resizeData);
        this._snowContainer.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        if(resizeData.orientation === Orientation.LANDSCAPE) {
            if((NolimitApplication.screenBounds.left > this._gameLogo.position.x) || !(Helper.isDefaultScreenRatio(NolimitApplication.screenBounds))) {
                this._gameLogo.visible = false;
            } else {
                this._gameLogo.visible = true;
            }
        }
    }

    protected arrangeGraphicsOnResize(resizeData?:IResizeData):void {
        this._winCountupScreen.position.set(-280, 0);
        this._bigwinScreen.position.set(-280, 0);

        let stoneTexture = GameResources.getTextures(BarbarianFuryGameAssets.MAIN_GAME_STONE_FOREGROUND)[0],
            stoneScaling = 1;

        if(this._deviceOrientation === "landscape") {
            this._reelBottomFire.position.set(-280, 605);
            this._gameLogo.scale.set(0.5);
            this._gameLogo.position.set(-155, 110);
            this.hideBonusMoon();
            stoneScaling = (this._screenWidth / (stoneTexture.width - 400)); // reducing 400px extra space on left & right of the image
        } else {
            this._reelBottomFire.position.set(-280, 615);
            this._gameLogo.visible = true;
            this._gameLogo.scale.set(1);
            this._gameLogo.position.set(this._screenWidth / 2, -this._gameLogo.height / 1.9);
            if(resizeData && resizeData!.bottom <= 960) {
                this._gameLogo.scale.set(0.55);
                this._gameLogo.position.set(this._screenWidth / 2, -this._gameLogo.height / 3.6);
            }
            this.showBonusMoon();
            stoneScaling = 1;

        }
        this._stoneForeground.scale.set(stoneScaling);
        this._stoneForeground.position.set(360, 860);
    }

    protected onChangeBackground(data:IGameModeChangedData):boolean {
        let isModeChanged:boolean = super.onChangeBackground(data);

        if(data.newMode === BarbarianFuryGameMode.NORMAL) {
            this.switchGraphicsToMainGame();
        } else {
            this.switchGraphicsToBonusGame();
        }

        return isModeChanged;
    }

    protected switchGraphicsToMainGame():void {
        // main game settings
        this._gameMode = BarbarianFuryGameMode.NORMAL;

        this._frameChainLeft.texture = this.getTextureForBG(BarbarianFuryGameAssets.MAIN_GAME_REEL_CHAIN);
        this._frameChainRight.texture = this.getTextureForBG(BarbarianFuryGameAssets.MAIN_GAME_REEL_CHAIN);

        this._fireParticlesAnim.stopLoop();
        this._fireParticlesAnim.visible = false;

        this._reelFrame.texture = this.getTextureForBG(BarbarianFuryGameAssets.MAIN_GAME_REEL_FRAME);

        for(let i:number = 0; i < this._snowContainer.children.length; ++i) {
            (this._snowContainer.children[i] as TimelineSprite).visible = true;
            (this._snowContainer.children[i] as TimelineSprite).playLoop();
        }

        for(let i:number = 0; i < this._reelBottomFire.children.length; ++i) {
            (this._reelBottomFire.children[i] as TimelineSprite).visible = false;
            (this._reelBottomFire.children[i] as TimelineSprite).stopLoop();
        }

        this.hideBonusMoon();

        this._stoneForeground.texture = this.getTextureForBG(BarbarianFuryGameAssets.MAIN_GAME_STONE_FOREGROUND);

        EventHandler.dispatchEvent(new GameEvent(BFGameEvent.UPDATE_MULTIPLIER_BG, "mainGameMultiplierBg"));
    }

    protected switchGraphicsToBonusGame():void {
        // bonus game settings
        this._gameMode = BarbarianFuryGameMode.FREESPIN;

        this._frameChainLeft.texture = this.getTextureForBG(BarbarianFuryGameAssets.BONUS_GAME_REEL_CHAIN);
        this._frameChainRight.texture = this.getTextureForBG(BarbarianFuryGameAssets.BONUS_GAME_REEL_CHAIN);

        this._fireParticlesAnim.playLoop();
        this._fireParticlesAnim.visible = true;

        this._reelFrame.texture = this.getTextureForBG(BarbarianFuryGameAssets.BONUS_GAME_REEL_FRAME);

        for(let i:number = 0; i < this._snowContainer.children.length; ++i) {
            (this._snowContainer.children[i] as TimelineSprite).visible = false;
            (this._snowContainer.children[i] as TimelineSprite).stopLoop();
        }

        for(let i:number = 0; i < this._reelBottomFire.children.length; ++i) {
            (this._reelBottomFire.children[i] as TimelineSprite).visible = true;
            (this._reelBottomFire.children[i] as TimelineSprite).playLoop();
        }

        this.showBonusMoon();

        this._stoneForeground.texture = this.getTextureForBG(BarbarianFuryGameAssets.BONUS_GAME_STONE_FOREGROUND);

        EventHandler.dispatchEvent(new GameEvent(BFGameEvent.UPDATE_MULTIPLIER_BG, "bonusGameMultiplierBg"));

        //todo SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.FS_THUNDER_STRIKE);
    }

    private createGameGraphics():void {
        this._reelBackground.scale.set(0.962);
        this._reelBackground.position.set(22, 0);

        //frame chain left
        this._frameChainLeft = this.createBgItem(BarbarianFuryGameAssets.MAIN_GAME_REEL_CHAIN);
        this._frameChainLeft.rotation = 120;
        this._frameChainLeft.anchor.set(0);
        this._frameChainLeft.position.set(-50, 370);
        this._reelForeground.addChild(this._frameChainLeft);

        //frame chain right
        this._frameChainRight = this.createBgItem(BarbarianFuryGameAssets.MAIN_GAME_REEL_CHAIN);
        this._frameChainRight.scale.x *= -1;
        this._frameChainRight.rotation = 100;
        this._frameChainRight.anchor.set(0);
        this._frameChainRight.position.set(735, 310);
        this._reelForeground.addChild(this._frameChainRight);

        // gameLogo Graphic
        this._gameLogo = new PIXI.Sprite(GameResources.getTextures(BarbarianFuryGameAssets.INTRO_LOGO)[0]);
        this._gameLogo.anchor.set(0.5);
        this._reelForeground.addChild(this._gameLogo);

        //fire animation behind the reels
        const backgroundFireContainer:PIXI.Container = new PIXI.Container();
        this._fireParticlesAnim = new TimelineSprite(GameResources.getTextures("smokeFireParticles"), 20);
        this._fireParticlesAnim.blendMode = PIXI.BLEND_MODES.ADD;
        this._fireParticlesAnim.anchor.set(0);
        this._fireParticlesAnim.position.set(-280, 300);
        this._fireParticlesAnim.visible = false;
        backgroundFireContainer.addChild(this._fireParticlesAnim);
        this._layer.addChild(backgroundFireContainer);

        //moon in bonus game
        const bonusGameMoonBG:PIXI.Container = new PIXI.Container();
        this._fsMoon = this.createBgItem(BarbarianFuryGameAssets.BONUS_GAME_MOON_BG);
        this._fsMoon.anchor.set(0);
        this._fsMoon.position.set(210, -170);
        this.hideBonusMoon();
        bonusGameMoonBG.addChild(this._fsMoon);
        this._layer.addChild(bonusGameMoonBG);

        //reel frame
        this._reelFrame = this.createBgItem(BarbarianFuryGameAssets.MAIN_GAME_REEL_FRAME);
        this._reelFrame.anchor.set(0, 0);
        this._reelFrame.position.set(-65, 0);
        this._reelForeground.addChild(this._reelFrame);

        //snowfall always in background
        this.createSnowFall();

        //reel bottom fire animation
        this.createBottomReelFire();

        //stone in foreground
        this._stoneForeground = this.createBgItem(BarbarianFuryGameAssets.MAIN_GAME_STONE_FOREGROUND);
        this._stoneForeground.anchor.set(0.5);

        this._gameForeground.addChild(this._stoneForeground);

        this.arrangeGraphicsOnResize();
    }

    private createSnowFall():void {
        const backgroundSnowContainer:PIXI.Container = new PIXI.Container(),
            length:number = 8;

        for(let k:number = 0; k < 3; ++k) {
            for(let i:number = 0; i < length; ++i) {
                for(let j:number = 0; j < length; ++j) {
                    let item:TimelineSprite = new TimelineSprite(GameResources.getTextures("snowFall"));
                    item.blendMode = PIXI.BLEND_MODES.ADD;
                    item.position.set(j * 250, i * 250);
                    backgroundSnowContainer.addChild(item);
                }
            }
        }

        this._snowBackground.addChild(backgroundSnowContainer);
        this._snowContainer = backgroundSnowContainer;
    }

    private createBottomReelFire():void {
        const bottomFireAnimation:PIXI.Container = new PIXI.Container(),
            length:number = 9;

        for(let i:number = 0; i < length; ++i) {
            let item:TimelineSprite = new TimelineSprite(GameResources.getTextures("reelBottomFire"), 20);
            item.position.set(i * 120, 0);
            item.blendMode = PIXI.BLEND_MODES.ADD;
            item.visible = false;

            bottomFireAnimation.addChild(item);
        }

        this._gameForeground.addChild(bottomFireAnimation);
        this._reelBottomFire = bottomFireAnimation;
    }

    private createBgItem(name:string):PIXI.Sprite {
        let item:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(name)[0]);
        return item;
    }

    private getTextureForBG(name:string):PIXI.Texture {
        let item:PIXI.Texture = GameResources.getTextures(name)[0];
        return item;
    }

    protected hideBonusMoon():void {
        this._fsMoon.visible = false;
    }

    protected showBonusMoon():void {
        if((this._gameMode.indexOf(BarbarianFuryGameMode.FREESPIN) > -1) && (this._deviceOrientation === "portrait")) {
            this._fsMoon.visible = true;
        }
    }
}